module.exports = __webpack_public_path__ + "static/media/klaukre6gl_1680x1050.f2633663.jpg";